export default __webpack_public_path__ + "static/media/logo-cadunico-web.ce9387a6.png";